module.exports = __webpack_public_path__ + "static/media/male-active.b394d959.svg";